import React from "react";
import { Outlet } from "react-router-dom";
import ServiceViewLayout from "../../ServiceViewLayout/ServiceViewLayout";
import { FaCommentDollar } from "react-icons/fa6";
import { GrMoney } from "react-icons/gr";
type Props = {};

const TabDSCServiceWrapper = (props: Props) => {

  const navItemsList = [
    {
      label: "Commission",
      path:"commission",
      icon: FaCommentDollar,
    },
    {
      label: "Reward",
      path:"reward",
      icon: GrMoney,
    },
  ];

  return (
    <ServiceViewLayout navItemList={navItemsList} >
      <Outlet/>
    </ServiceViewLayout>
  );
};

export default TabDSCServiceWrapper;
